import { del, getJson, patchJson, postJson, putJson } from 'utils/http';

export type WorkHistoryJob = {
  id: string;
  synonymId: string | null | undefined;
  text: string;
  titleSuggestion: string | null | undefined;
  title?: {
    selectedId: string;
    selectedText: string;
    standardId: string;
    standardText: string;
    text?: string;
  };
  orgName: string | null | undefined;
  orgId: string | null | undefined;
  isCurrent: boolean;
  startDate: (string | null | undefined) | (number | null | undefined);
  endDate: (string | null | undefined) | (number | null | undefined);
  positionType: 'JOB' | 'INTERNSHIP' | 'VOLUNTEER';
  isFullTime: boolean;
  managerialStatus: boolean;
};

export type Location = {
  latitude: number | undefined;
  longitude: number | undefined;
  city: string;
  countryCode: string | undefined;
  stateCode: string | undefined;
  full: string;
};

export type ApplicantProfile = {
  id: string;
  willingToRelocate: boolean | null | undefined;
  prefersRemote: boolean | null | undefined;
  openToRemote: boolean | null | undefined;
  location: Location | null | undefined;
  skills: Array<string>;
  workHistoryJobs: Array<WorkHistoryJob>;
  updatedByUser: string;
  summary: string | null;
};

export type ApplicantProfileResponse = {
  resumeId: string | null;
  isRecruitable: boolean | null;
  applicantProfile: ApplicantProfile | null;
};

const emptyProfile = {
  resumeId: null,
  isRecruitable: null,
  workHistoryJobs: [],
  skills: [],
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function mapProfileResponse({ applicantProfile }: any) {
  const {
    resumeS3FileId: resumeId,
    isRecruitable,
    ...profile
  } = applicantProfile || emptyProfile;
  return {
    resumeId,
    isRecruitable,
    applicantProfile: profile,
  };
}

export function fetchApplicantProfile(): Promise<ApplicantProfileResponse> {
  return getJson('/data/userdashboard/applicant-profile/profile').then(
    mapProfileResponse,
  );
}

export function updateApplicantProfile(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  values: Record<string, any>,
): Promise<ApplicantProfileResponse> {
  return patchJson(
    '/data/userdashboard/applicant-profile/profile',
    values,
  ).then(mapProfileResponse);
}

export function addWorkHistoryJob(
  job: WorkHistoryJob,
): Promise<ApplicantProfileResponse> {
  return postJson(
    '/data/userdashboard/applicant-profile/work-history/jobs',
    job,
  ).then(mapProfileResponse);
}

export function editWorkHistoryJob(
  id: string,
  job: WorkHistoryJob,
): Promise<ApplicantProfileResponse> {
  return putJson(
    `/data/userdashboard/applicant-profile/work-history/jobs/${id}`,
    job,
  ).then(mapProfileResponse);
}

export function deleteWorkHistoryJob(
  id: string,
): Promise<ApplicantProfileResponse> {
  return del(
    `/data/userdashboard/applicant-profile/work-history/jobs/${id}`,
  ).then(mapProfileResponse);
}

export function fetchUserByEmail(email: string) {
  return getJson(
    `/data/users/by-email?email=${encodeURIComponent(email)}`,
  ).then(
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    (result) => result && result.userExists,
  );
}
